import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "wimt-select",
  templateUrl: "./wimt-select.component.html",
  styleUrls: ["./wimt-select.component.scss"],
  standalone: false,
})
export class WimtSelectComponent {
  @Input() items: string[];
  @Input() searchable: boolean = true;
  @Input() clearable: boolean = false;
  @Input() placeholder: string = "Select item";
  @Input() selectedItem: string;

  @Output() valueChange = new EventEmitter<string>();

  constructor() {}
}
